import Script from 'next/script';
import useMatchMedia from '@/hooks/useMatchMedia';
import PageHead from '@/components/common/PageHead';

import Container from '@/components/common/Container';
import Section from '@/components/common/Section';
import Heading from '@/components/common/Heading';
import ClientOnly from '@/components/common/ClientOnly';
import Box from '@/components/common/Box/Box';

import ServicesIntroduction from '@/components/Pages/Services/ServicesIntroduction';
import ServicesLayout from '@/components/Pages/Services/ServicesLayout';
import ServicesBlock from '@/components/Pages/Services/ServicesBlock';
import Info from '@/components/Pages/Index/Info';
import FAQs from '@/components/Pages/Index/FAQs';
import InnerHero from '@/components/InnerHero';
import BackgroundHero from '@/components/common/Background/BackgroundHero';

import webdesignBlock from '@/db/services/webdesign/webdesignBlock.json';
import faqs from '@/db/services/webdesign/webdesignFaq.json';
import info from '@/db/services/webdesign/webdesignInfo.json';
import innerHero from '@/db/services/webdesign/webdesignHero.json';
import introduction from '@/db/services/webdesign/webdesignIntroduction.json';

import webdesignMeta from '@/db/services/webdesign/webdesignMeta.json';
import ss_webdesign from '@/db/seoscript/ss_webdesign.json';

const WebDesign = () => {
  const { isMobile } = useMatchMedia();
  return (
    <>
      <PageHead {...webdesignMeta} />

      <Box className=" relative">
        <Container>
          <Section className="pt-0 pb-0 lg:pb-4">
            <InnerHero innerHero={innerHero} />
          </Section>
        </Container>
        <BackgroundHero />
      </Box>

      <Container>
        <Section className=" lg:mx-[150px]">
          <Heading headingLevel="h2" className="text-center mb-5 md:mb-16  ">
            Web Design
          </Heading>
          <ServicesIntroduction introduction={introduction} />
        </Section>
      </Container>

      <Container>
        <Section>
          <ServicesBlock webdesignBlock={webdesignBlock} />
        </Section>
      </Container>

      <Container>
        <Section className="px-0 md:px-[50px]">
          <Heading headingLevel="h2" className=" text-center mb-5 md:mb-16">
            Transforming Ideas into Engaging Web Designs
          </Heading>
          <Info info={info} />
        </Section>
      </Container>

      <Container>
        <Section>
          <Heading headingLevel="h2" className="text-center mb-5 md:mb-16">
            <ClientOnly>
              {isMobile ? 'FAQs' : 'Frequently Asked Questions'}
            </ClientOnly>
          </Heading>
          <FAQs faqs={faqs} />
        </Section>
      </Container>

      <Script
        id="ss_webdesign"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(ss_webdesign) }}
      />
    </>
  );
};

WebDesign.PageLayout = ServicesLayout;

export default WebDesign;
